module.exports = __webpack_public_path__ + "img/icon-arrow.d2baab3a.svg";